


































import { Component } from 'vue-property-decorator';
import {
  FieldsItemModel,
  fieldsItems,
} from '@web/models/HomeModels/FieldsItemModell';
import HomeSection from './Section.abstract';

@Component
export default class HomeFields extends HomeSection {
  abc = '@shared/assets/Science_BG.svg';

  public fieldsItems: FieldsItemModel[] = fieldsItems;

  imagesAppeareence = true;

  headersAppearence = true;

  imagesRefs = {
    science: 'science',
    technology: 'technology',
    reading: 'reading',
    engineering: 'engineering',
    math: 'math',
    art: 'art',
    sel: 'sel',
  };

  headersRefs = {
    header: 'header',
    footer: 'footer',
  };
}
